import './App.css';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import theme from './config/theme'
import {ThemeProvider} from '@material-ui/styles';
import {create} from 'jss';
import rtl from 'jss-rtl';
import {jssPreset, StylesProvider} from '@material-ui/core/styles';
import React from "react";
import ContextProvider from "./contexts";
import InsertedDevices from './pages/devices/inserted-devices';
import SignIn from "./pages/signin";

const jss = create({plugins: [...jssPreset().plugins, rtl()]});

function App() {
    return (
        <ContextProvider>
            <StylesProvider jss={jss}>
                <ThemeProvider theme={theme}>
                    <Router>
                        <Switch>
                            <Route path="/signin" exact>
                                <SignIn/>
                            </Route>
                            <Route path="/">
                                <InsertedDevices/>
                            </Route>
                        </Switch>
                    </Router>
                </ThemeProvider>
            </StylesProvider>
        </ContextProvider>
    );
}

export default App;
